import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private readonly _toastr: ToastrService) {}

  public error(msg: any, title: string = 'Error') {
    // Errors need reading (and often acting) time — don't let them vanish on
    // the short default timeout (WCAG P2-6).
    this._toastr.error(msg, title, { timeOut: 10000, extendedTimeOut: 5000 });
  }

  public success(msg: string, title: string = 'Success') {
    this._toastr.success(msg, title);
  }

  public warning(msg: string, title: string = 'Warning') {
    // Same reading-time budget as errors: a warning usually asks for a
    // follow-up action
    this._toastr.warning(msg, title, { timeOut: 10000, extendedTimeOut: 5000 });
  }
}
